import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const ChipRow = () => (
  <div style={{ display: 'flex', gap: 'var(--space-sm)', flexWrap: 'wrap' }}>
    <SkeletonBox width={80} height={28} borderRadius="999px" />
    <SkeletonBox width={120} height={28} borderRadius="999px" />
    <SkeletonBox width={96} height={28} borderRadius="999px" />
    <SkeletonBox width={72} height={28} borderRadius="999px" />
  </div>
);

const InsightSection = ({ headingWidth, withChips, bodyLines }) => (
  <section
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-sm)',
      padding: 'var(--space-lg)',
      borderRadius: 'var(--radius-lg)',
      border: '1px solid var(--color-border)',
      background: 'var(--color-surface)',
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
      <SkeletonCircle size={32} />
      <SkeletonText widths={[headingWidth]} lineHeight="20px" />
    </div>
    {withChips ? (
      <ChipRow />
    ) : (
      <SkeletonText
        lines={bodyLines}
        widths={['100%', '92%', '78%', '64%']}
        lineHeight="16px"
        gap="0.5rem"
      />
    )}
  </section>
);

const DocumentInsightsSkeleton = () => (
  <div
    aria-hidden="true"
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-lg)',
      padding: 'clamp(1.5rem, 4vw, 3rem)',
      maxWidth: '920px',
      margin: '0 auto',
    }}
  >
    {/* Header */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)' }}>
      <SkeletonText widths={['min(420px, 70vw)']} lineHeight="32px" />
      <SkeletonText widths={['min(560px, 80vw)']} lineHeight="14px" />
    </div>

    {/* Stats row */}
    <div style={{ display: 'flex', gap: 'var(--space-md)', flexWrap: 'wrap' }}>
      <SkeletonBox width={140} height={56} borderRadius="var(--radius-md)" />
      <SkeletonBox width={140} height={56} borderRadius="var(--radius-md)" />
      <SkeletonBox width={140} height={56} borderRadius="var(--radius-md)" />
    </div>

    {/* Sections */}
    <InsightSection headingWidth="180px" withChips />
    <InsightSection headingWidth="220px" bodyLines={4} />
    <InsightSection headingWidth="160px" bodyLines={3} />
  </div>
);

export default DocumentInsightsSkeleton;
